<template>
  <div class="container mx-auto">
    <el-dialog title="Nuevo banco" :visible.sync="showNewBank" width="350px">
      <el-form
        :model="newBankForm"
        status-icon
        :rules="newBankFormRules"
        ref="newBank"
        @submit.native.prevent="submitNewBank('newBank', newBankForm)"
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de banco" prop="name">
                  <el-input
                    placeholder="Nombre de banco"
                    v-model="newBankForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="País" prop="country">
                  <el-select
                    v-model="newBankForm.country"
                    placeholder="Select"
                    size="small"
                    class="w-full"
                  >
                    <el-option
                      v-for="c in countries"
                      :key="c.id"
                      :label="c.name"
                      :value="c.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showNewBank = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="Editar banco" :visible.sync="showEditBank" width="350px">
      <el-form
        :model="editBankForm"
        status-icon
        :rules="editBankFormRules"
        ref="editBank"
        @submit.native.prevent="
          submitNewBank('editBank', editBankForm, editBankForm.id)
        "
      >
        <el-row :gutter="15" class="flex items-center justify-center">
          <el-col :span="24">
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="Nombre de banco" prop="name">
                  <el-input
                    placeholder="Nombre de banco"
                    v-model="editBankForm.name"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="15" class="flex items-center justify-center">
              <el-col :span="24" class="flex flex-col justify-center">
                <el-form-item label="País" prop="country">
                  <el-select
                    v-model="editBankForm.country"
                    placeholder="Seleccionar"
                    size="small"
                    class="w-full"
                  >
                    <el-option
                      v-for="c in countries"
                      :key="c.id"
                      :label="c.name"
                      :value="c.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-form-item class="flex justify-end mb-0">
          <el-button size="small" @click="showEditBank = false"
            >Cancelar</el-button
          >
          <el-button size="small" type="primary" native-type="submit"
            >Guardar</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-row :gutter="15" type="flex" justify="start">
      <el-col :span="12">
        <el-row :gutter="15">
          <el-col :span="24" class="mb-5">
            <h3 class="text-l font-semibold">BANCOS</h3>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="24">
            <el-alert
              :closable="false"
              title="Aquí se administran los diferentes bancos por pais que se utilizan en el sistema."
              type="info"
              show-icon
            />
          </el-col>
        </el-row>
        <el-row :gutter="15" type="flex" justify="space-between" class="my-5">
          <el-col :span="8">
            <el-button type="primary" size="small" @click="openNewBankDialog"
              >Nuevo banco</el-button
            >
          </el-col>
          <el-col :span="10">
            <el-input
              placeholder="Buscar"
              v-model="searchValue"
              size="small"
              suffix-icon="el-icon-search"
            ></el-input>
          </el-col>
        </el-row>
        <el-table :data="filteredBanks" stripe size="mini">
          <el-table-column type="index" width="40" />
          <el-table-column
            prop="name"
            label="Nombre del banco"
            min-width="200"
          />
          <el-table-column label="Pais" min-width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.country.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Estado" min-width="100" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.active">
                <el-tag type="success" size="small">Activo</el-tag>
              </span>
              <span v-else>
                <el-tag type="warning" size="small">Inactivo</el-tag>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="address" width="60" align="center">
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <el-button
                  icon="el-icon-fa-ellipsis-v"
                  size="small"
                ></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="openEditBankDialog(scope.row)"
                  >
                    <i class="el-icon-fa-pencil"></i> Editar información
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="changeStatus(scope.row)">
                    <span v-if="scope.row.active">
                      <i class="el-icon-fa-times"></i> Desactivar
                    </span>
                    <span v-else>
                      <i class="el-icon-fa-check"></i> Activar
                    </span>
                    banco
                  </el-dropdown-item>
                  <el-dropdown-item
                    :divided="true"
                    class="text-red-500 font-semibold"
                    @click.native="deleteBank(scope.row)"
                  >
                    <i class="el-icon-fa-trash"></i> Eliminar
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-row :gutter="15" type="flex" justify="end" class="mt-5">
          <el-pagination
            @size-change="handleSizeChange"
            :current-page.sync="page.number"
            :page-sizes="[5, 10, 15, 25, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next"
            :total="rawBanks.length"
            :pager-count="5"
          />
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from "axios";
import * as R from "ramda";
import * as V from "voca";

export default {
  name: "SettingsBanks",
  beforeRouteEnter(to, from, next) {
    axios
      .post("/", {
        query: `{ banks { id name active country { name } } }`,
      })
      .then((res) => {
        const { data, errors } = res.data;
        if (R.isNil(errors)) {
          next((vm) => vm.setData(data.banks));
        } else {
          next(new Error(errors[0].message));
        }
      });
  },
  data() {
    return {
      rawBanks: [],
      searchValue: "",
      page: {
        size: 15,
        number: 1,
      },
      countries: [],
      showNewBank: false,
      newBankForm: {
        name: "",
        country: null,
      },
      newBankFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Selecciona un país.",
            trigger: "change",
          },
        ],
      },
      showEditBank: false,
      editBankForm: {
        name: "",
        country: null,
      },
      editBankFormRules: {
        name: [
          {
            required: true,
            message: "Por favor agrega el nombre completo.",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "Selecciona un país.",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    setData(data) {
      this.rawBanks = data;
    },
    handleSizeChange(val) {
      this.page.size = val;
    },
    changeStatus(bank) {
      const action = bank.active ? "desactivar" : "activar";
      const message = `¿Estás seguro que deseas ${action} este banco?`;
      const saveText = `Si, ${V.titleCase(action)}`;
      this.$confirm(message, "Confirmación", {
        confirmButtonText: saveText,
        cancelButtonText: "Cancelar",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = "Procesando...";
            axios
              .post("/", {
                query: `
                mutation { 
                  bankUpdateStatus
                  ( where: { id: ${bank.id} } active: ${!bank.active} )
                  { id name active country { name } }
                }`,
              })
              .then((res) => {
                const { data, errors } = res.data;
                if (R.isNil(errors)) {
                  this.rawBanks = data.bankUpdateStatus;
                }
                this.$notify({
                  title: R.isNil(errors) ? "Éxito" : "Error",
                  message: R.isNil(errors)
                    ? "Se ha cambiado el estado correctamente"
                    : errors[0].message,
                  type: R.isNil(errors) ? "success" : "error",
                  duration: 3500,
                });
                instance.confirmButtonLoading = false;
                instance.confirmButtonText = saveText;
                done();
              });
          } else {
            done();
          }
        },
      });
    },
    deleteBank({ id }) {
      this.$confirm(
        "¿Estás seguro que deseas eliminar este banco?",
        "Confirmación",
        {
          confirmButtonText: "Si, eliminar",
          cancelButtonText: "Cancelar",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Procesando...";
              axios
                .post("/", {
                  query: `mutation { bankDelete( where: {id: ${id}} ) { id name active country { name } } }`,
                })
                .then((res) => {
                  const { data, errors } = res.data;
                  if (R.isNil(errors)) {
                    this.rawBanks = data.bankDelete;
                  }
                  this.$notify({
                    title: R.isNil(errors) ? "Éxito" : "Error",
                    message: R.isNil(errors)
                      ? "Se ha eliminado el banco correctamente"
                      : errors[0].message,
                    type: R.isNil(errors) ? "success" : "error",
                    duration: 3500,
                  });
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Si, eliminar";
                  done();
                });
            } else {
              done();
            }
          },
        }
      );
    },
    openNewBankDialog() {
      axios
        .post("/", {
          query: `{ countries { id name } }`,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            this.countries = data.countries;
          }
          const ref = this.$refs["newBank"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showNewBank = true;
        });
    },
    openEditBankDialog({ id }) {
      axios
        .post("/", {
          query: `
          { 
            bank(where: { id: ${id} }) { id name active country { id name } }
            countries { id name }
          }
          `,
        })
        .then((res) => {
          const { data, errors } = res.data;
          if (R.isNil(errors)) {
            const country = data.bank.country.id;
            this.editBankForm = { ...data.bank, country };
            this.countries = data.countries;
          }
          const ref = this.$refs["editBank"];
          if (!R.isNil(ref)) {
            ref.resetFields();
          }
          this.showEditBank = true;
        });
    },
    submitNewBank(formName, { name, shortName, country }, bankId = false) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        const action = bankId ? "editar" : "crear";
        const mutation = bankId
          ? `bankEdit(data: { name: "${name}", country: ${country} } where: { id: ${bankId} } )`
          : `bankCreate(data: { name: "${name}", country: ${country} } )`;
        this.$confirm(
          `¿Estás seguro que deseas ${action} este banco?`,
          "Confirmación",
          {
            confirmButtonText: `Si, ${action}`,
            cancelButtonText: "Cancelar",
            type: "warning",
            beforeClose: (action, instance, done) => {
              if (action === "confirm") {
                instance.confirmButtonLoading = true;
                instance.confirmButtonText = "Procesando...";
                axios
                  .post("/", {
                    query: `mutation { 
                      ${mutation}
                      { id name active country { name } }
                    }`,
                  })
                  .then((res) => {
                    const { data, errors } = res.data;
                    if (R.isNil(errors)) {
                      this.rawBanks = bankId ? data.bankEdit : data.bankCreate;
                    }
                    this.$notify({
                      title: R.isNil(errors) ? "Éxito" : "Error",
                      message: R.isNil(errors)
                        ? `Se ha creado el banco correctamente`
                        : errors[0].message,
                      type: R.isNil(errors) ? "success" : "error",
                      duration: 3500,
                    });
                    this.showNewBank = false;
                    this.showEditBank = false;
                    instance.confirmButtonLoading = false;
                    instance.confirmButtonText = `Si, ${action}`;
                    done();
                  });
              } else {
                done();
              }
            },
          }
        );
      });
    },
  },
  computed: {
    filteredBanks() {
      return this.rawBanks
        .filter((document) => {
          return (
            document.name
              .toLowerCase()
              .includes(this.searchValue.toLowerCase()) ||
            document.country.name
              .toLowerCase()
              .includes(this.searchValue.toLowerCase())
          );
        })
        .slice(
          this.page.number * this.page.size - this.page.size,
          this.page.size * this.page.number
        );
    },
  },
};
</script>
